import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const ASSIGNMENT_VALUES = {
  'partCode': '',
  'partName': '',
  'stock': 0,
  'icc': '',
  'invoices': {},
  'location': '',
  'lastLocation': '',
  'newLocation': '',
  'reservedLocations': [],
  'newReservedLocations': [],
};

const INITIAL_STATE = {
  'assigning': false,
  'checkingAssignments': false,
  'submittingAssignments': false,
  'loadingFreeLocations': false,
  'loadingAssignmentsList': false,
  'loadingPartAssignment': false,
  'freeLocations': [],
  'assignments': [],
  'warehouse': '',
  'count': 0,
  'limit': 20,
  'offset': 0,
  'loadingPartReplacement': false,
  'partReplacement': {},
  'newLocationModal': false,
  'newReservedLocationsModal': false,
  'selectedIndex': -1,
};

const removeAssignment = (assignments, index) => {
  const updatedAssignments = [...assignments];
  updatedAssignments.splice(index, 1);

  return updatedAssignments;
};

const updateValue = (assignments, {index, name, value}) => {
  const updatedAssignments = [...assignments];
  const selectedRow = {...updatedAssignments[index]};
  selectedRow[name] = value;
  updatedAssignments.splice(index, 1, selectedRow);

  return updatedAssignments;
};

const updateRow = (assignments, index, info) => {
  const updatedAssignments = [...assignments];
  updatedAssignments[index] = info;

  return updatedAssignments;
};

export const locationsAssignment = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LOCATIONS_ASSIGNMENT]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.GETTING_FREE_LOCATIONS]: (state, action) => ({
      ...state,
      'loadingFreeLocations': true,
    }),
    [ActionTypes.GOTTEN_FREE_LOCATIONS]: (state, action) => ({
      ...state,
      'loadingFreeLocations': false,
      'freeLocations': action.response.data,
      'warehouse': action.payload,
    }),
    [ActionTypes.GOTTEN_FREE_LOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'loadingFreeLocations': false,
      'freeLocations': [],
      'warehouse': '',
    }),
    [ActionTypes.GETTING_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': true,
    }),
    [ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': false,
      'assignments': action.response.data,
    }),
    [ActionTypes.GOTTEN_WAREHOUSE_ALLOCATIONS_FAILED]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': false,
      'assignments': [],
    }),
    [ActionTypes.CHANGE_WAREHOUSE_ALLOCATIONS_PAGE]: (state, action) => ({
      ...state,
      'offset': action.payload,
    }),
    [ActionTypes.ADD_LOCATION_ASSIGNMENT]: (state, action) => ({
      ...state,
      'assignments': [...state.assignments, ASSIGNMENT_VALUES],
      'assigning': true,
    }),
    [ActionTypes.REMOVE_LOCATION_ASSIGNMENT]: (state, action) => ({
      ...state,
      'assignments': removeAssignment(state.assignments, action.payload),
    }),
    [ActionTypes.UPDATE_ASSIGNMENT_VALUE]: (state, action) => ({
      ...state,
      'assignments': updateValue(state.assignments, action.payload),
    }),
    [ActionTypes.CHECKING_ASSIGNMENT_IMPORT]: (state, action) => ({
      ...state,
      'checkingAssignments': true,
    }),
    [ActionTypes.CHECKED_ASSIGNMENT_IMPORT]: (state, action) => ({
      ...state,
      'checkingAssignments': false,
      'assignments': action.response.data,
    }),
    [ActionTypes.CHECKED_ASSIGNMENT_IMPORT_FAILED]: (state, action) => ({
      ...state,
      'checkingAssignments': false,
    }),
    [ActionTypes.GETTING_ASSIGNMENTS_LIST]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': true,
    }),
    [ActionTypes.GOTTEN_ASSIGNMENTS_LIST]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': false,
      'assigning': false,
      'assignments': action.response.data,
      'count': action.response.count,
    }),
    [ActionTypes.GOTTEN_ASSIGNMENTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingAssignmentsList': false,
      'assignments': [],
      'count': 0,
    }),
    [ActionTypes.GETTING_PART_ASSIGNMENT]: (state, action) => ({
      ...state,
      'loadingPartAssignment': true,
    }),
    [ActionTypes.GOTTEN_PART_ASSIGNMENT]: (state, action) => ({
      ...state,
      'loadingPartAssignment': false,
      'assigning': false,
      'assignments': updateRow(state.assignments, action.payload, action.response.data),
    }),
    [ActionTypes.GOTTEN_PART_ASSIGNMENT_FAILED]: (state, action) => ({
      ...state,
      'loadingPartAssignment': false,
    }),
    [ActionTypes.SUBMITTING_LOCATIONS_ASSIGNMENT]: (state, action) => ({
      ...state,
      'submittingAssignments': true,
    }),
    [ActionTypes.SUBMITTED_LOCATIONS_ASSIGNMENT]: (state, action) => ({
      ...state,
      'submittingAssignments': false,
      'assignments': [],
      'count': 0,
    }),
    [ActionTypes.SUBMITTED_LOCATIONS_ASSIGNMENT_FAILED]: (state, action) => ({
      ...state,
      'submittingAssignments': false,
    }),
    [ActionTypes.FETCHING_PART_REPLACEMENT]: (state, action) => ({
      ...state,
      'loadingPartReplacement': true,
    }),
    [ActionTypes.FETCHED_PART_REPLACEMENT]: (state, action) => ({
      ...state,
      'loadingPartReplacement': false,
      'partReplacement': action.response.data,
    }),
    [ActionTypes.FETCHED_PART_REPLACEMENT_FAILED]: (state, action) => ({
      ...state,
      'loadingPartReplacement': false,
      'partReplacement': {},
    }),
    [ActionTypes.SHOW_NEW_LOCATIONS_MODAL]: (state, action) => ({
      ...state,
      'newLocationModal': true,
      'selectedIndex': action.payload.index,
    }),
    [ActionTypes.HIDE_NEW_LOCATIONS_MODAL]: (state, action) => ({
      ...state,
      'newLocationModal': false,
    }),
    [ActionTypes.SHOW_NEW_RESERVED_LOCATIONS_MODAL]: (state, action) => ({
      ...state,
      'newReservedLocationsModal': true,
      'selectedIndex': action.payload.index,
    }),
    [ActionTypes.HIDE_NEW_RESERVED_LOCATIONS_MODAL]: (state, action) => ({
      ...state,
      'newReservedLocationsModal': false,
    }),
  })(state, action);
};
